export default "__VITE_ASSET__3NG5UcBQ__"